export function StyleCleaner (pEditor, pStyle)
{
  this.cleanupHTML = (pButton, content, args = {}) =>
  {
    var i, n,
        elements,
        saveContent,
        selectedElement,
        isRangeContent = false,
        currentSelection,
        currentRange,
        currentUniSelection,
        currentUniRange,
        simplifyFormattingRet,
        nodeName,
        attrs,
        attrName,
        matchContent,
        matchTags,
        matchTagsName,
        reMatchTagsName = /<\/?([A-Za-z0-9]+)/ig,
        startTags = [],
        startTagsStr = '',
        startTagsRE,
        endTags = [],
        endTagsStr = '',
        endTagsRE,
        rangeElements,
        rangeElementStart,
        rangeElementEnd,
        parentElementStart,
        parentElementEnd,
        parentElement,
        parentTable,
        rangeElementEndAnchor,
        rangeElementEndPosition,
        isStartFix = false,
        isEndFix = false,

        rules =
        {
          trueTags:
          {
            'P': true,
            'H1': true,
            'H2': true,
            'H3': true,
            'H4': true,
            'H5': true,
            'H6': true,
            'UL': true,
            'OL': true,
            'LI': true,
            'BLOCKQUOTE': true,
            'TABLE': true,
            'THEAD': true,
            'TBODY': true,
            'TFOOT': true,
            'TR': true,
            'TH': true,
            'TD': true,
            'DIV': function (element)
            {
              var isChange = false,
                  isRemove = false,
                  isNotModify = false,
                  parentElement;

              if (pEditor.$Style(element, 'position').toLowerCase() !== 'absolute')
              {
                if (element.hasAttribute('data-componentId') || element.hasAttribute('data-editableArea'))
                {
                  isRemove = true;
                }
                else
                {
                  parentElement = element.parentElement;
                  element.outerHTML = element.outerHTML.replace(/^<div/i, '<p data-wadivtagconverter="1"').replace(/div>$/i, 'p>');
                  element = parentElement.querySelector('P[data-wadivtagconverter]');
                  element.removeAttribute('data-wadivtagconverter');
                  isChange = true;
                }
              }
              else
              {
                isNotModify = true;
              }

              return {'isRemove': isRemove, 'isChange': isChange, 'isNotModify': isNotModify, 'element': (isChange ? element : null)};
            },
            'A': true,
            'IMG': function (element) { return {'isRemove': (/^file:/i).test(element.getAttribute('src')), 'isChange': false, 'element': null}; },
            'BR': true
          },

          reEmptyTags: /^(?:P|H1|H2|H3|H4|H5|H6|BLOCKQUOTE|A)$/i,

          trueAttributes:
          {
            'width':
            {
              'tags': /^(?:IMG|TABLE|TH|TD)$/i,
              'values': /^\d+(?:px|%)?$/i
            },

            'height':
            {
              'tags': /^(?:IMG|TABLE|TH|TD)$/i,
              'values': /^\d+(?:px|%)?$/i,
              'trans': function (element, attr)
              {
                if (BEditor.browser.isIE && attr.value.indexOf('%') !== -1 && (element.nodeName === 'TH' || element.nodeName === 'TD'))
                {
                  element.removeAttribute(attr.name);
                }
              }
            },

            'alt':
            {
              'tags': /IMG/i,
              'values': /./i
            },

            'title':
            {
              'tags': /^(?:IMG|A)$/i,
              'values': /./i
            },

            'src':
            {
              'tags': /IMG/i,
              'values': /./i
            },

            'href':
            {
              'tags': /A/i,
              'values': /./i
            },

            'name':
            {
              'tags': /A/i,
              'values': /./i
            },

            'cellspacing':
            {
              'tags': /TABLE/i,
              'values': /^\d+(?:px)?$/i
            },

            'cellpadding':
            {
              'tags': /TABLE/i,
              'values': /^\d+(?:px)?$/i
            },

            'data-':
            {
              'tags': /./i,
              'values': /./i
            }
          },

          trueStyles:
          [
            {
              'rule': 'position',
              'tags': /^(?:DIV|IMG)$/i,
              'values': /absolute/i
            }
          ],

          styles2Tags:
          [
          ]
        };

    if (content == null)
    {
      if (pEditor.pThis.isObjValid > 1 && $(pEditor.iFrameId) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
      {
        currentSelection = pEditor.range.selection.getCurrent();
        currentRange = pEditor.range.getCurrent();

        if ((BEditor.browser.isIE && currentSelection.type.toUpperCase() !== 'NONE' && currentSelection.type.toUpperCase() !== 'CONTROL') || (!BEditor.browser.isIE && !currentRange.collapsed))
        {
          rangeElements = pEditor.helpers.element.getCurrentParentElements(currentRange);

          for (i = 0; i < rangeElements.length; i++)
          {
            if (rangeElements[i].nodeName === 'TH' || rangeElements[i].nodeName === 'TD')
            {
              parentTable = rangeElements[i];

              while (parentTable && parentTable.nodeName !== 'TABLE')
              {
                parentTable = parentTable.parentNode;
              }

              if (parentTable)
              {
                pEditor.range.setCursorPoint(parentTable, true);
                break;
              }
            }
          }

          if (!parentTable)
          {
            rangeElementStart = rangeElements[0];
            rangeElementEnd = rangeElements[1];

            parentElementStart = pEditor.helpers.element.getParentElementFromElementByTagsNames(rangeElementStart, pEditor.checkAllBlockTags);
            parentElementEnd = pEditor.helpers.element.getParentElementFromElementByTagsNames(rangeElementEnd, pEditor.checkAllBlockTags);

            if (parentElementStart !== parentElementEnd)
            {
              currentUniSelection = pEditor.range.selection.getCurrent(true);
              currentUniRange = pEditor.range.getCurrent(true);

              if (currentUniRange)
              {
                parentElement = currentUniRange.commonAncestorContainer;

                while (parentElementStart && parentElementStart.nodeName !== 'BODY' && parentElementStart.parentNode.nodeName !== 'BODY' && parentElementStart.parentNode !== parentElement)
                {
                  parentElementStart = parentElementStart.parentNode;
                }

                while (parentElementEnd && parentElementEnd.nodeName !== 'BODY' && parentElementEnd.parentNode.nodeName !== 'BODY' && parentElementEnd.parentNode !== parentElement)
                {
                  parentElementEnd = parentElementEnd.parentNode;
                }

                currentUniSelection.removeAllRanges();

                if (parentElementStart.nodeName !== 'BODY')
                {
                  currentUniRange.setStartBefore(parentElementStart);
                }

                if (parentElementEnd !== 'BODY')
                {
                  currentUniRange.setEndAfter(parentElementEnd);
                }

                currentUniSelection.addRange(currentUniRange);

                currentSelection = pEditor.range.selection.getCurrent();
                currentRange = pEditor.range.getCurrent();
                rangeElements = pEditor.helpers.element.getCurrentParentElements(currentRange);
                rangeElementStart = rangeElements[0];
                rangeElementEnd = rangeElements[1];
              }
            }

            rangeElementStart.setAttribute('data-watemprangeelementstart', 1); //TODO:Dime !!!
            rangeElementEnd.setAttribute('data-watemprangeelementend', 1);

            content = pEditor.range.content.getHTML(true);

            if (BEditor.device.isIOS)
            {
              selectedElement = content.selectedElement;
              content = content.selectedHTML;
            }
          }
          else
          {
            rangeElementStart = parentTable;
            rangeElementEnd = parentTable;
            rangeElementStart.setAttribute('data-watemprangeelementstart', 1);
            rangeElementEnd.setAttribute('data-watemprangeelementend', 1);
            content = parentTable.outerHTML;
          }
        }
      }

      if (content == null)
      {
        content = pEditor.content.getHtmlData();
      }
      else
      {
        isRangeContent = true;
        saveContent = content;
      }
    }

    if (content && content.length > 0)
    {
      simplifyFormattingRet = pStyle.simplifier.simplifyFormatting(content, {'rules': rules, 'isClearEmptyTags': true});
      content = simplifyFormattingRet.htmlContent;

      if (isRangeContent)
      {
        if (!parentTable)
        {
          if (rangeElementStart !== rangeElementEnd)
          {
            matchTags = content.match(/^(?:<[A-Za-z0-9]+(?:\s[^>]*>|>))+/i);

            if (matchTags && matchTags.length === 2)
            {
              while (matchTagsName = reMatchTagsName.exec(matchTags[1]))
              {
                if (matchTagsName && matchTagsName.length === 2)
                {
                  startTags.push(matchTagsName[1].toUpperCase());
                }
              }

              isStartFix = true;
            }

            i = startTags.length - 1;

            while (i >= 0 && rangeElementStart && rangeElementStart.nodeName !== 'BODY' && isStartFix)
            {
              if (!rules.trueTags[rangeElementStart.nodeName])
              {
                rangeElementStart = rangeElementStart.parentNode;
              }
              else
              {
                if (rangeElementStart.nodeName !== startTags[i])
                {
                  isStartFix = false;
                }
                else if (i > 0)
                {
                  rangeElementStart = rangeElementStart.parentNode;
                }

                i--;
              }
            }

            matchTags = content.match(/(?:<\/[A-Za-z0-9]+\s*>)+$/i);

            if (matchTags && matchTags.length === 2)
            {
              while (matchTagsName = reMatchTagsName.exec(matchTags[1]))
              {
                if (matchTagsName && matchTagsName.length === 2)
                {
                  endTags.push(matchTagsName[1].toUpperCase());
                }
              }

              isEndFix = true;
            }

            i = endTags.length - 1;

            while (i >= 0 && rangeElementEnd && rangeElementEnd.nodeName !== 'BODY' && isEndFix)
            {
              if (!rules.trueTags[rangeElementEnd.nodeName])
              {
                rangeElementEnd = rangeElementEnd.parentNode;
              }
              else
              {
                if (rangeElementEnd.nodeName !== endTags[i])
                {
                  isEndFix = false;
                }
                else if (i > 0)
                {
                  rangeElementEnd = rangeElementEnd.parentNode;
                }

                i--;
              }
            }
          }
          else if (rangeElementStart.nodeType === 1 && pEditor.checkAllBlockTags.test(rangeElementStart.nodeName) && rangeElementStart.nodeName !== 'BODY' && rangeElementStart.style.position.toLowerCase() !== 'absolute' && rangeElementStart.innerHTML === saveContent)
          {
            nodeName = rangeElementStart.nodeName.toUpperCase();
            attrs = rangeElementStart.attributes;

            for (n = attrs.length; n--;)
            {
              attrName = attrs[n].name.toLowerCase();

              if ((rules.trueAttributes[attrName] || (attrName.indexOf('data-') === 0 && rules.trueAttributes['data-'])) && rules.trueAttributes[attrName].tags.test(nodeName) && attrs[n].value && ((typeof(rules.trueAttributes[attrName].values) === 'function' && rules.trueAttributes[attrName].values(rangeElementStart, attrs[n].value)) || (typeof(rules.trueAttributes[attrName].values) === 'object' && rules.trueAttributes[attrName].values.test(attrs[n].value))))
              {
                if (rules.trueAttributes[attrName].trans)
                {
                  rules.trueAttributes[attrName].trans(rangeElementStart, attrs[n]);
                }
              }
              else
              {
                rangeElementStart.removeAttribute(attrs[n].name);
              }
            }
          }

          if (BEditor.device.isIOS && selectedElement)
          {
            selectedElement.outerHTML = content;
          }
          else
          {
            pEditor.helpers.insertHTML(content);
          }

          rangeElementStart = pEditor.iFrameDoc.querySelector('[data-watemprangeelementstart]');
          rangeElementEnd = pEditor.iFrameDoc.querySelector('[data-watemprangeelementend]');

          elements  = pEditor.iFrameDoc.querySelectorAll('[data-watemprangeelementstart], [data-watemprangeelementend]');

          for (i = 0; i < elements.length; i++)
          {
            elements[i].removeAttribute('data-watemprangeelementstart');
            elements[i].removeAttribute('data-watemprangeelementend');
          }

          pEditor.range.cursor.show(rangeElementEnd, false);

          if (rangeElementStart)
          {
            elements = rangeElementStart.getElementsByTagName('*');

            for (i = elements.length; i--;)
            {
              if (!rules.trueTags[elements[i].nodeName.toUpperCase()] && elements[i].innerHTML === '')
              {
                elements[i].parentNode.removeChild(elements[i]);
              }
            }
          }

          if (rangeElementEnd && rangeElementEnd !== rangeElementStart)
          {
            elements = rangeElementEnd.getElementsByTagName('*');

            for (i = elements.length; i--;)
            {
              if (!rules.trueTags[elements[i].nodeName.toUpperCase()] && elements[i].innerHTML === '')
              {
                elements[i].parentNode.removeChild(elements[i]);
              }
            }
          }

          if (isStartFix && rangeElementStart)
          {
            for (i = startTags.length; i--;)
            {
              startTagsStr += '</' + startTags[i] + '\\s*>';
            }

            for (i = 0; i < startTags.length; i++)
            {
              startTagsStr += '<' + startTags[i] + '(?:\\s[^>]*>|>)';
            }

            startTagsRE = new RegExp(startTagsStr, 'i');

            if (rangeElementStart.nextSibling && rangeElementStart.nextSibling.nodeType === 1)
            {
              matchContent = rangeElementStart.outerHTML + rangeElementStart.nextSibling.outerHTML;
              rangeElementStart.nextSibling.parentNode.removeChild(rangeElementStart.nextSibling);
            }
            else
            {
              matchContent = rangeElementStart.outerHTML;
            }

            rangeElementStart.outerHTML = matchContent.replace(startTagsRE, '');
          }

          if (isEndFix && rangeElementEnd)
          {
            for (i = endTags.length; i--;)
            {
              endTagsStr += '</' + endTags[i] + '\\s*>';
            }

            for (i = 0; i < endTags.length; i++)
            {
              endTagsStr += '<' + endTags[i] + '(?:\\s[^>]*>|>)';
            }

            endTagsRE = new RegExp(endTagsStr, 'i');

            if (rangeElementEnd.previousSibling && rangeElementEnd.previousSibling.nodeType === 1)
            {
              matchContent = rangeElementEnd.previousSibling.outerHTML + rangeElementEnd.outerHTML;
              rangeElementEnd.previousSibling.parentNode.removeChild(rangeElementEnd.previousSibling);
            }
            else
            {
              matchContent = rangeElementEnd.outerHTML;
            }

            rangeElementEndPosition = !!rangeElementEnd.nextSibling;
            rangeElementEndAnchor = rangeElementEndPosition ? rangeElementEnd.nextSibling : rangeElementEnd.parentNode;

            rangeElementEnd.outerHTML = matchContent.replace(endTagsRE, '');

            if (rangeElementEndAnchor)
            {
              rangeElementEnd = rangeElementEndPosition ? rangeElementEndAnchor.previousSibling : rangeElementEndAnchor.lastChild;
              pEditor.range.cursor.show(rangeElementEnd, false);
            }
          }
        }
        else
        {
          parentTable.outerHTML = content;
        }
      }
      else
      {
         pEditor.html.editor.setHTML(content);
      }

      pEditor.helpers.restoreEditorEntities();
    }
  };
}